import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormulariosDiscapacidadComponent } from './formularios-discapacidad.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LayoutModule } from 'app/layout/layout.module';

import { FuseSharedModule } from '@fuse/shared.module';
import { FuseHighlightModule } from '@fuse/components';

const routes = [
    {
        path     : 'formularios-discapacidad',
        component: FormulariosDiscapacidadComponent
    }
  ];

@NgModule({
  declarations: [FormulariosDiscapacidadComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatSnackBarModule,
    FlexLayoutModule,
    LayoutModule,
    FuseSharedModule,
    FuseHighlightModule
  ]
})
export class FormulariosDiscapacidadModule { }
